//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const CommentWrapper = styled.div`
  width: 100%;
  
  td {
    text-overflow: initial;
    vertical-align: top;
    white-space: initial;
  }

  .td-comment {
    word-break: break-word;
    hyphens: auto;
  }

  .td-attachments {
    max-width: 10em;

    a {
      word-break: break-all;
    }
  }
`
